// src/app/slices/starterSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { deleteAccessory } from './actions';
import { IStarter, IStarterParams, AccessoryState } from '../models';

const initialState: AccessoryState<IStarter, IStarterParams> = {
  accessories: {},
  params: null,
};

const starterSlice = createSlice({
  name: 'starter',
  initialState,
  reducers: {
    setStarter: (state, action: PayloadAction<IStarter>) => {
      if (!state.accessories[action.payload.section_id])
        state.accessories[action.payload.section_id] = {};
      state.accessories[action.payload.section_id][action.payload.id] =
        action.payload;
    },
    setStarterParams: (state, action: PayloadAction<IStarterParams>) => {
      state.params = action.payload;
    },
    deleteStarter: deleteAccessory,
  },
});

export const { setStarter, setStarterParams, deleteStarter } = starterSlice.actions;

export default starterSlice.reducer;
